import React from 'react';

import { Size, Variant } from './types';

import AlertCircleFilled from '../../assets/AlertCircleFilled.svg?react';
import CheckCircleFilled from '../../assets/CheckCircleFilled.svg?react';
import InfoCircle from '../../assets/InfoCircle.svg?react';
import InfoCircleFilled from '../../assets/InfoCircleFilled.svg?react';
import WarningFilled from '../../assets/WarningFilled.svg?react';

export const textClassNamesBySize: { [key in Size]: string } = {
  sm: 'text-sm',
  md: 'text-b3',
  lg: 'text-b2',
  xl: 'text-h3',
  xxl: 'text-h1',
};

export const textClassNamesByVariant: { [key in Variant]: string } = {
  info: 'text-info-strong',
  success: 'text-success-strong',
  warning: 'text-warning-strong',
  error: 'text-danger-strong',
  light: 'text-tertiary',
};

export const iconClassNamesBySize: { [key in Size]: string } = {
  sm: 'w-md h-md',
  md: 'w-xmd h-xmd',
  lg: 'w-lg h-lg',
  xl: 'w-xl h-xl',
  xxl: 'w-xxl h-xxl',
};

export const iconClassNamesByVariant: { [key in Variant]: string } = {
  info: 'icon-info-strong',
  success: 'icon-success-strong',
  warning: 'icon-warning-strong',
  error: 'icon-danger-strong',
  light: 'icon-secondary',
};

export const iconByVariant: { [key in Variant]: React.ReactElement } = {
  info: <InfoCircleFilled />,
  success: <CheckCircleFilled />,
  warning: <AlertCircleFilled />,
  error: <WarningFilled />,
  light: <InfoCircle />,
};
